module.exports = __webpack_public_path__ + "img/check-circle.d784b771.svg";